import type { FaireProductEntity } from "../../entity_types/product";

export const p_pmjcj47u4x: FaireProductEntity = {
  token: "p_pmjcj47u4x",
  type: "product",
  name: "Dulce 18K Gold Non-Tarnish CZ Double Hoop Stud",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/03aae8085846c3ea0963283ab365a5f3babb373e5523348fed9be395647e6cbe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd48af555c9aa406a499947d25e15ba864ce4add939346ead0b4844d78654f6d.jpeg",
    "https://cdn.faire.com/fastly/1979c40105bbb749f3dc22ce6371d787b52571e56db1e3f3ed808bed2ee8a769.jpeg",
    "https://cdn.faire.com/fastly/49184c354424e8ae076a50cdd1cd3711df80b76782903b65783f2a0c9e0b9587.jpeg",
    "https://cdn.faire.com/fastly/b74e2a3f3f6113efb0a54ea8c636ac566f90caac6bb239072df9f40330b7f5e9.jpeg",
  ],
  priceDollars: 9.87,
  description:
    "18K Gold Non-Tarnish CZ Double Hoop Stud\n18K Gold Plating\nStainless Steel\nRhinestone\nMeasurement (L x W inch): 0.48inx0.28in\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:29.082Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
